<template>
  <client-container>
    <template v-if="$store.getters['brand/showStore']" slot="header">
      <router-link
        :to="{ name: 'orderShopStep' }"
        class="button is-rounded is-light"
      >
        <b-icon
          icon="shopping-cart"
          size="is-small"
          class="has-margin-right-0"
        />
        <b-icon
          icon="arrow-right"
          size="is-small"
          class="has-text-grey-light"
        />
      </router-link>
    </template>
    <ribbon slot="section">
      <u-padding>
        <column :key="$route.path">
          <router-view />
        </column>
      </u-padding>
    </ribbon>
  </client-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Contexts } from "@/models/contexts";

export default defineComponent({
  name: "LoggedOutClientDefaultLayout",
  components: {
    "client-container": () => import("@/skeleton/client/clientContainer.vue")
  },
  created() {
    window.addEventListener("storage", this.onLocalStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onLocalStorageChange);
  },
  methods: {
    async onLocalStorageChange({ key, newValue, oldValue }) {
      if (!oldValue && newValue) {
        if (key === `${Contexts.CLIENT}/auth/token/access_token`)
          window.location.reload();
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.ribbon {
  align-self: center;
  @include responsive-padding-y;
  .column {
    max-width: 32rem;
    margin: auto;
  }
}
</style>
